<template>
  <div
    :class="
      $vuetify.breakpoint.smAndUp
        ? 'notifications_container'
        : 'notifications_container mobile'
    "
  >
    <v-list class="notification_list" width="100%">
      <v-list-item
        class="pa-0"
        v-for="(item, index) in notifications"
        :key="index"
      >
        <v-list-item-content class="d-block pa-0">
          <div class="notification_text pl-12 py-6 pr-8">
            {{ item.body }}
            <div
              class="notification_dot"
              :style="{
                backgroundColor:
                  item.type === 'error' ? '#E32929' : '#379C41',
              }"
            ></div>
          </div>

          <div class="divider"></div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="mt-8 mb-9 justify-center">
        <v-btn
          class="show_all"
          width="212px"
          height="50px"
          outlined
          rounded
          color="#2C4370"
          @click="goNotification()"
        >
          Show all notif
        </v-btn>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import {getLastNotifications} from "@/api/notification";
export default {
  name: "Notifications",
  data: () => ({
    shown: false,
    notifications: [],
  }),
  mounted() {
    const self = this;
    self.getNotifications(1);
    setInterval(() => {
      self.getNotifications(0);
    }, 30000);
  },
  methods: {
    getNotifications() {
      return new Promise((resolve, reject) => {
        getLastNotifications()
            .then((data) => {
              this.notifications = data.data;
              resolve(data);
            })
            .catch(error => {
              reject(error);
            });
      });
    },
    goNotification() {
      this.shown = false;
      this.$router.push('notification');
    }
  }
};
</script>
<style scoped>
.notifications_container {
  width: 420px;
  box-shadow: 0px 30px 30px rgba(0, 0, 0, 0.07);
  border-radius: 20px;
  margin-left: 8px !important;
  position: absolute;
  top: 10px;
  background-color: #fff;
  z-index: 10;
}
.mobile {
  width: calc(100vw - 40px);
  right: -95px;
  margin-right: 27px;
}
.notification_list {
  border-radius: 20px !important;
  width: 100% !important;
}
.notification_btn {
  background-color: #fff;
  position: relative;
}
.new_messages {
  position: absolute;
  right: 7px;
  top: -20px;
  width: 10px;
  height: 10px;
  background-color: #ed5050;
  border-radius: 50%;
}
.show_notif {
  text-transform: none !important;
  font-size: 18px !important;
}
.notification_text {
  white-space: pre-wrap;
  color: #2c4370;
  font-size: 14px;
  line-height: 17px;
  position: relative;
  text-transform: none;
  text-align: left;
}
.notification_dot {
  position: absolute;
  top: 29px;
  left: 28px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.show_all {
  text-transform: none;
  font-size: 18px;
}
.notification_btn_over {
  background-color: #fff;
  position: absolute;
  top: -30px;
}
.over_desktop {
  left: calc(50% - 29px);
}
.over_mobile {
  right: 64px;
}
.divider {
  width: 100%;
  height: 1px;
  background-color: #eaeaea;
}
</style>
